import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';
import { checkAddress, syncOption } from './side-menu';

/**
 * It reads click an all custom selects
 * @param {String} query - It is the query selector
 */
const onClickCustomSelect = (query) => {
  const customSelect = $Q(query);
  if (!customSelect) return;

  customSelect.addEventListener('click', () => {
    toggleShowCustomOptions(customSelect);
    onClickOutsideSelect(customSelect);
  });
};

/**
 * It shows or hide custom options for custom select
 */
const toggleShowCustomOptions = () => {
  const customOptions = $Q('.custom-select__items');
  if (!customOptions) return;

  dataToggle(customOptions.parentNode);
};

/**
 * It hides the select options when it is clicked outside of it
 * @param {HTMLElement} select - It is the select detected
 */
const onClickOutsideSelect = (select) => {
  document.addEventListener('click', (e) => {
    if (!select.contains(e.target)) {
      const parent = select.closest('.account-sidebar__options');
      const options = $Q('.custom-select__items', parent);

      if (!options) return;

      parent.dataset.active = 'false';
    }
  });
};

/**
 * It hides current clicked item
 * @param {HTMLElement} option : It is the option clicked
 * @param {HTMLCollection} options : It is the group of options
 */
const hideClickedValue = (option, options) => {
  if (window.location.pathname.includes('account')) return;

  options.forEach((item) => {
    if (item === option) {
      item.classList.add('hidden');
    } else {
      item.classList.remove('hidden');
    }
  })
}

/**
 * Read click and mouseover on custom select options
 * @param {String} query - It is the query selector
 */
const onClickCustomOption = (query) => {
  const customOptions = $Qll(query);
  if (!customOptions) return;

  customOptions.forEach((option, index) => {
    option.addEventListener('click', (event) => {
      if (
        window.location.pathname.includes('pages')
        && !window.location.pathname.includes('faq')) return;

      const isAddress = checkAddress(option, index);
      if (isAddress) return;

      event.preventDefault();
      assignSelectedValue(option);
      hideClickedValue(option, customOptions);
      $Q('.account-sidebar__options').dataset.active = false;
      syncOption(option, '.account-sidebar__desktop li');
    });
  });
};

/**
 * Assigns value to selected option
 * @param {HTMLElement} option : It is the option clicked
 */
const assignSelectedValue = (option) => {
  const selectedOption = $Q('.custom-select__selected');
  if (!selectedOption) return;

  selectedOption.dataset.id = option.dataset.id;

  if (option.firstElementChild !== null && option.firstElementChild.nodeName === 'A') {
    selectedOption.firstElementChild.innerText = option.firstElementChild.textContent.trim();
  } else {
    selectedOption.firstElementChild.innerText = option.innerText.trim();
  }

  selectedOption.parentNode.dataset.selected = option.dataset.id;
};

/**
 * Get storage click to view a determined section
 */
 const getStorageClick = () => {
  const storageClick = JSON.parse(sessionStorage.getItem('sidebar-clicked'));
  if (window.location.pathname.includes('addresses')) return;

  if (storageClick) {
    const link = $Q(`.custom-select__items  li[data-id="${storageClick.id}"]`);
    setTimeout(() => {
      link.click();
      sessionStorage.removeItem('sidebar-clicked');
    }, 0);
  }
}

/* Initializes custom select */
export const initializeCustomSelect = () => {
  getStorageClick();
  onClickCustomSelect('.custom-select__selected');
  onClickCustomOption('.custom-select__items li');
};
